import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=492a1ec6&scoped=true"
import script from "./main-footer.vue?vue&type=script&lang=ts"
export * from "./main-footer.vue?vue&type=script&lang=ts"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=492a1ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a1ec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
